module.exports = __webpack_public_path__ + "img/MY-A2K4060A-AD.b13867e4.png";